import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { IconStylingModel } from '../icon/icon-styling.model';
export class DatatableRowsExpanderStylingModel extends CoreStylingModel {
/**
 * Styling of expandAllIcon by IconStylingModel
 */
expandAllIcon?: IconStylingModel;
/**
 * Styling of collapseAllIcon by IconStylingModel
 */
collapseAllIcon?: IconStylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DatatableRowsExpanderStylingModel_tsickle_Closure_declarations() {
/**
 * Styling of expandAllIcon by IconStylingModel
 * @type {?}
 */
DatatableRowsExpanderStylingModel.prototype.expandAllIcon;
/**
 * Styling of collapseAllIcon by IconStylingModel
 * @type {?}
 */
DatatableRowsExpanderStylingModel.prototype.collapseAllIcon;
}

